import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { BehaviorSubject } from 'rxjs';
import { SchoolDirectory, DirectoryUser, DirectoryDepartment, DirectorySchool } from 'src/app/shared/models/school.directory';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
import { MobileUiService } from 'src/app/shared/services/mobile-ui.service';

@Component({
  selector: 'app-home-directory',
  templateUrl: './home-directory.component.html',
  styleUrls: ['./home-directory.component.scss']
})
export class HomeDirectoryComponent implements OnInit {
  directory = new BehaviorSubject<SchoolDirectory>(null);
  directoryClean: SchoolDirectory;
  schools = new BehaviorSubject<DirectorySchool[]>(null);
  departments = new BehaviorSubject<DirectoryDepartment[]>(null);
  profiles = new BehaviorSubject<DirectoryUser[]>(null);
  selectedSchool: string;
  selectedDepartment: string;
  isParentDirectory: boolean;
  dummyPhoto = '../../assets/default-user.jpg';
  faAngleDoubleLeft = faAngleDoubleLeft;
  isMobile = new BehaviorSubject<boolean>(false);
  isLoading = true;

  constructor(private apiService: ApiService, private mobileUiService: MobileUiService) {
    this.isMobile = this.mobileUiService.isMobile;
  }

  ngOnInit(): void {
    this.getDirectory();
  }

  getDirectory(): void {
    this.isLoading = true;
    this.apiService.getDirectory().subscribe((dir: SchoolDirectory) => {
      const departments = [] as DirectoryDepartment[];
      const profiles = [] as DirectoryUser[];

      dir.schools.map(school => school.departments.map(dept => {
        departments.push(dept);
        dept.users.map(user => profiles.push(user));
      }));

      this.schools.next(dir.schools);
      this.departments.next(departments);
      this.profiles.next(profiles);
      this.directory.next(dir);
      this.directoryClean = dir;
      this.isLoading = false;
    });
  }

  filterDirectory(school = this.selectedSchool, department = null): void {
    // TODO: Filter faculty by shchool and department
    // Should be able to use filter and map to populate behavoir subjects
    // Potentially this function could also be used in a search
    this.selectedSchool = school;
    this.selectedDepartment = department;
    const departments = [] as DirectoryDepartment[];
    const profiles = [] as DirectoryUser[];
    this.schools.next(this.schools.value.filter(x => x.name === school));

    this.schools.value.map(x => x.departments.filter(y => department != null ? y.name === department : y).map(dept => {
      departments.push(dept);
      dept.users.map(user => profiles.push(user));
    }));

    this.departments.next(departments);
    this.profiles.next(profiles);
  }

  clearSchool(): void {
    this.getDirectory();
    this.schools.next(this.directory.value.schools);
    this.selectedSchool = null;
    this.selectedDepartment = null;
  }

  clearDepartment(): void {
    const departments = [] as DirectoryDepartment[];
    const profiles = [] as DirectoryUser[];

    this.schools.value.map(x => x.departments.map(dept => {
      departments.push(dept);
      dept.users.map(user => profiles.push(user));

      this.profiles.next(profiles);
      this.departments.next(departments);
    }));

    this.departments.next(departments);
    this.profiles.next(profiles);
    this.selectedDepartment = null;
  }

}